<template>
  <div class="box">
    <div class="box__wrapper">
      <div
        v-if="$slots.icon"
        class="box__icon"
      >
        <slot name="icon" />
      </div>
      <div class="box__content">
        <slot />
        <div class="box__actions">
          <div>
            <slot name="left-action" />
          </div>
          <div>
            <slot name="right-action" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'box',
};
</script>

<style lang="scss" scoped>
.box {
  color: var(--v-primary-base, $clr-primary);
  border: 1px solid currentColor;
  padding: 16px;
  border-radius: 4px;
  position: relative;

  &__wrapper {
    position: relative;
    z-index: 1;
    display: flex;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: currentColor;
    opacity: 0.03;
  }

  &__icon {
    flex: 0 0 auto;
    & + * { margin-left: 23px; }
  }

  &__content {
    color: var(--v-navy-medium-base, $clr-navy-medium);
    font-size: 16px;
    line-height: 1.5;
    font-weight: 500;
    flex-grow: 1;

    &::v-deep {
      p { margin: 0; }

      p + p { margin-top: 0.5em; }

      a:not([class]) {
        text-decoration: underline;

        &:hover { text-decoration: none; }
      }

      ul {
        line-height: 32px;
        padding: 0 0 0 15px;

        li {
          position: relative;

          &::before {
            content: '';
            position: absolute;
            top: 16px;
            transform: translateY(-50%);
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background-color: currentColor;
            left: -15px;
          }
        }
      }
    }
  }

  &__actions {
    display: flex;
    justify-content: space-between;
  }

  &::v-deep.has-error,
  &::v-deep.has-error a,
  &::v-deep.has-error .icon,
  &::v-deep.has-error &__content {
    color: var(--v-error-base, $clr-error);
  }

  &.has-error .primary--text {
    color: var(--v-error-base, $clr-error) !important;
  }
}
</style>
